// @ts-nocheck
const URL = process.env.PUBLIC_URL + '/assets/scenes/level1.gltf'
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from "three";
import React, { useEffect, useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";

type GLTFResult = GLTF & {
  nodes: {
    InteractiveTile: THREE.Mesh;
    InteractiveTile001: THREE.Mesh;
    InteractiveTile002: THREE.Mesh;
    InteractiveTile003: THREE.Mesh;
    InteractiveTile004: THREE.Mesh;
    InteractiveTile005: THREE.Mesh;
    InteractiveTile006: THREE.Mesh;
    InteractiveTile007: THREE.Mesh;
    InteractiveTile008: THREE.Mesh;
    InteractiveTile009: THREE.Mesh;
    InteractiveTile010: THREE.Mesh;
    InteractiveTile011: THREE.Mesh;
    InteractiveTile012: THREE.Mesh;
    InteractiveTile013: THREE.Mesh;
    InteractiveTile014: THREE.Mesh;
    InteractiveTile015: THREE.Mesh;
    InteractiveTile016: THREE.Mesh;
    InteractiveTile017: THREE.Mesh;
    InteractiveTile018: THREE.Mesh;
    InteractiveTile019: THREE.Mesh;
    InteractiveTile020: THREE.Mesh;
    InteractiveTile021: THREE.Mesh;
    InteractiveTile022: THREE.Mesh;
    InteractiveTile023: THREE.Mesh;
    InteractiveTile024: THREE.Mesh;
    InteractiveTile025: THREE.Mesh;
    InteractiveTile026: THREE.Mesh;
    InteractiveTile027: THREE.Mesh;
    InteractiveTile028: THREE.Mesh;
    InteractiveTile029: THREE.Mesh;
    InteractiveTile030: THREE.Mesh;
    InteractiveTile031: THREE.Mesh;
    InteractiveTile032: THREE.Mesh;
    InteractiveTile033: THREE.Mesh;
    InteractiveTile034: THREE.Mesh;
    InteractiveTile035: THREE.Mesh;
    InteractiveTile036: THREE.Mesh;
    InteractiveTile037: THREE.Mesh;
    InteractiveTile038: THREE.Mesh;
    InteractiveTile039: THREE.Mesh;
    InteractiveTile040: THREE.Mesh;
    InteractiveTile041: THREE.Mesh;
    InteractiveTile042: THREE.Mesh;
    InteractiveTile043: THREE.Mesh;
    InteractiveTile044: THREE.Mesh;
    InteractiveTile045: THREE.Mesh;
    InteractiveTile046: THREE.Mesh;
    InteractiveTile047: THREE.Mesh;
    InteractiveTile048: THREE.Mesh;
    InteractiveTile049: THREE.Mesh;
    InteractiveTile050: THREE.Mesh;
    InteractiveTile051: THREE.Mesh;
    InteractiveTile052: THREE.Mesh;
    InteractiveTile053: THREE.Mesh;
    InteractiveTile054: THREE.Mesh;
    InteractiveTile055: THREE.Mesh;
    InteractiveTile056: THREE.Mesh;
    InteractiveTile057: THREE.Mesh;
    InteractiveTile058: THREE.Mesh;
    InteractiveTile059: THREE.Mesh;
    InteractiveTile060: THREE.Mesh;
    InteractiveTile061: THREE.Mesh;
    InteractiveTile062: THREE.Mesh;
    InteractiveTile063: THREE.Mesh;
    InteractiveTile064: THREE.Mesh;
    InteractiveTile065: THREE.Mesh;
    InteractiveTile066: THREE.Mesh;
    InteractiveTile067: THREE.Mesh;
    InteractiveTile068: THREE.Mesh;
    InteractiveTile069: THREE.Mesh;
    InteractiveTile070: THREE.Mesh;
    InteractiveTile071: THREE.Mesh;
    InteractiveTile072: THREE.Mesh;
    InteractiveTile073: THREE.Mesh;
    InteractiveTile074: THREE.Mesh;
    InteractiveTile075: THREE.Mesh;
    InteractiveTile076: THREE.Mesh;
    InteractiveTile077: THREE.Mesh;
    InteractiveTile078: THREE.Mesh;
    InteractiveTile079: THREE.Mesh;
    InteractiveTile080: THREE.Mesh;
    InteractiveTile081: THREE.Mesh;
    InteractiveTile082: THREE.Mesh;
    InteractiveTile083: THREE.Mesh;
    InteractiveTile084: THREE.Mesh;
    InteractiveTile085: THREE.Mesh;
    InteractiveTile086: THREE.Mesh;
    InteractiveTile087: THREE.Mesh;
    InteractiveTile088: THREE.Mesh;
    InteractiveTile089: THREE.Mesh;
    InteractiveTile090: THREE.Mesh;
    InteractiveTile091: THREE.Mesh;
    InteractiveTile092: THREE.Mesh;
    InteractiveTile093: THREE.Mesh;
    InteractiveTile094: THREE.Mesh;
    InteractiveTile095: THREE.Mesh;
    InteractiveTile096: THREE.Mesh;
    InteractiveTile097: THREE.Mesh;
    InteractiveTile098: THREE.Mesh;
    InteractiveTile099: THREE.Mesh;
    InteractiveTile100: THREE.Mesh;
    InteractiveTile101: THREE.Mesh;
    InteractiveTile102: THREE.Mesh;
    InteractiveTile103: THREE.Mesh;
    InteractiveTile104: THREE.Mesh;
    InteractiveTile105: THREE.Mesh;
    InteractiveTile106: THREE.Mesh;
    InteractiveTile107: THREE.Mesh;
    InteractiveTile108: THREE.Mesh;
    InteractiveTile109: THREE.Mesh;
    InteractiveTile110: THREE.Mesh;
    InteractiveTile111: THREE.Mesh;
    InteractiveTile112: THREE.Mesh;
    InteractiveTile113: THREE.Mesh;
    InteractiveTile114: THREE.Mesh;
    InteractiveTile115: THREE.Mesh;
    InteractiveTile116: THREE.Mesh;
    InteractiveTile117: THREE.Mesh;
    InteractiveTile118: THREE.Mesh;
    InteractiveTile119: THREE.Mesh;
    InteractiveTile120: THREE.Mesh;
    InteractiveTile121: THREE.Mesh;
    InteractiveTile122: THREE.Mesh;
    InteractiveTile123: THREE.Mesh;
    InteractiveTile124: THREE.Mesh;
    InteractiveTile125: THREE.Mesh;
    InteractiveTile126: THREE.Mesh;
    InteractiveTile127: THREE.Mesh;
    InteractiveTile128: THREE.Mesh;
    InteractiveTile129: THREE.Mesh;
    InteractiveTile130: THREE.Mesh;
    InteractiveTile131: THREE.Mesh;
    InteractiveTile132: THREE.Mesh;
    InteractiveTile133: THREE.Mesh;
    InteractiveTile134: THREE.Mesh;
    InteractiveTile135: THREE.Mesh;
    InteractiveTile136: THREE.Mesh;
    InteractiveTile137: THREE.Mesh;
    InteractiveTile138: THREE.Mesh;
    InteractiveTile139: THREE.Mesh;
    InteractiveTile140: THREE.Mesh;
    InteractiveTile141: THREE.Mesh;
    InteractiveTile142: THREE.Mesh;
    InteractiveTile143: THREE.Mesh;
    InteractiveTile144: THREE.Mesh;
    InteractiveTile145: THREE.Mesh;
    InteractiveTile146: THREE.Mesh;
    InteractiveTile147: THREE.Mesh;
    InteractiveTile148: THREE.Mesh;
    InteractiveTile149: THREE.Mesh;
    InteractiveTile150: THREE.Mesh;
    InteractiveTile151: THREE.Mesh;
    InteractiveTile152: THREE.Mesh;
    InteractiveTile153: THREE.Mesh;
    InteractiveTile154: THREE.Mesh;
    InteractiveTile155: THREE.Mesh;
    InteractiveTile156: THREE.Mesh;
    InteractiveTile157: THREE.Mesh;
    InteractiveTile158: THREE.Mesh;
    InteractiveTile159: THREE.Mesh;
    InteractiveTile160: THREE.Mesh;
    InteractiveTile161: THREE.Mesh;
    InteractiveTile162: THREE.Mesh;
    InteractiveTile163: THREE.Mesh;
    InteractiveTile164: THREE.Mesh;
    InteractiveTile165: THREE.Mesh;
    InteractiveTile166: THREE.Mesh;
    InteractiveTile167: THREE.Mesh;
    InteractiveTile168: THREE.Mesh;
    InteractiveTile169: THREE.Mesh;
    InteractiveTile170: THREE.Mesh;
    InteractiveTile171: THREE.Mesh;
    InteractiveTile172: THREE.Mesh;
    InteractiveTile173: THREE.Mesh;
    InteractiveTile174: THREE.Mesh;
    InteractiveTile175: THREE.Mesh;
    Cube216: THREE.Mesh;
    Cube216_1: THREE.Mesh;
    pathDirt005: THREE.Mesh;
    pathDirt006: THREE.Mesh;
    pathCobbled009: THREE.Mesh;
    pathCobbled010: THREE.Mesh;
    detail_graveyard005: THREE.Mesh;
    detail_graveyard006: THREE.Mesh;
    pathCobbled024: THREE.Mesh;
    pathCobbled025: THREE.Mesh;
    pathCobbled026: THREE.Mesh;
    pathCobbled027: THREE.Mesh;
    pathCobbled028: THREE.Mesh;
    pathCobbled029: THREE.Mesh;
    pathCobbled030: THREE.Mesh;
    Cylinder081: THREE.Mesh;
    Cylinder081_1: THREE.Mesh;
    Cylinder082: THREE.Mesh;
    Cylinder082_1: THREE.Mesh;
    Cylinder083: THREE.Mesh;
    Cylinder083_1: THREE.Mesh;
    Cylinder084: THREE.Mesh;
    Cylinder084_1: THREE.Mesh;
    Cylinder085: THREE.Mesh;
    Cylinder085_1: THREE.Mesh;
    Cylinder103: THREE.Mesh;
    Cylinder103_1: THREE.Mesh;
    Sphere014: THREE.Mesh;
    Sphere014_1: THREE.Mesh;
    Cube309: THREE.Mesh;
    Cube309_1: THREE.Mesh;
    Cube310: THREE.Mesh;
    Cube310_1: THREE.Mesh;
    Cube311: THREE.Mesh;
    Cube311_1: THREE.Mesh;
    Cube312: THREE.Mesh;
    Cube312_1: THREE.Mesh;
    Cube313: THREE.Mesh;
    Cube313_1: THREE.Mesh;
    Cube314: THREE.Mesh;
    Cube314_1: THREE.Mesh;
    Cube315: THREE.Mesh;
    Cube315_1: THREE.Mesh;
    Cube316: THREE.Mesh;
    Cube316_1: THREE.Mesh;
  };
  materials: {
    ["Material.001"]: THREE.MeshStandardMaterial;
    ["Material.013"]: THREE.MeshStandardMaterial;
    ["Material.007"]: THREE.MeshStandardMaterial;
    ["Material.004"]: THREE.MeshStandardMaterial;
    ["Material.006"]: THREE.MeshStandardMaterial;
    ["Material.008"]: THREE.MeshStandardMaterial;
    ["Material.005"]: THREE.MeshStandardMaterial;
    ["Material.003"]: THREE.MeshStandardMaterial;
    ["Material.015"]: THREE.MeshStandardMaterial;
    ["Mud.015"]: THREE.MeshStandardMaterial;
    ["DarkWood.028"]: THREE.MeshStandardMaterial;
    ["DarkWood.033"]: THREE.MeshStandardMaterial;
    ["Stone.044"]: THREE.MeshStandardMaterial;
    ["DarkWood.034"]: THREE.MeshStandardMaterial;
    ["Stone.056"]: THREE.MeshStandardMaterial;
    ["Stone.057"]: THREE.MeshStandardMaterial;
    ["Stone.058"]: THREE.MeshStandardMaterial;
    ["Stone.059"]: THREE.MeshStandardMaterial;
    ["Stone.060"]: THREE.MeshStandardMaterial;
    ["Stone.061"]: THREE.MeshStandardMaterial;
    ["Stone.062"]: THREE.MeshStandardMaterial;
    ["Black.057"]: THREE.MeshStandardMaterial;
    ["Stone.075"]: THREE.MeshStandardMaterial;
    ["Black.058"]: THREE.MeshStandardMaterial;
    ["Stone.076"]: THREE.MeshStandardMaterial;
    ["Black.059"]: THREE.MeshStandardMaterial;
    ["Stone.077"]: THREE.MeshStandardMaterial;
    ["Black.060"]: THREE.MeshStandardMaterial;
    ["Stone.078"]: THREE.MeshStandardMaterial;
    ["Black.061"]: THREE.MeshStandardMaterial;
    ["Stone.079"]: THREE.MeshStandardMaterial;
    ["Black.062"]: THREE.MeshStandardMaterial;
    ["Stone.080"]: THREE.MeshStandardMaterial;
    ["Orange.024"]: THREE.MeshStandardMaterial;
    ["GreenDark.012"]: THREE.MeshStandardMaterial;
    ["Mud.062"]: THREE.MeshStandardMaterial;
    ["DarkWood.099"]: THREE.MeshStandardMaterial;
  };
};

export function Model(props: JSX.IntrinsicElements["group"]) {
  const { nodes, materials } = useGLTF(URL) as GLTFResult;

  return (
    <group {...props} dispose={null}>
      <mesh
        name="InteractiveTile"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile.geometry}
        material={materials["Material.001"]}
        position={[5.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile" }}
      />
      <mesh
        name="InteractiveTile001"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile001.geometry}
        material={materials["Material.013"]}
        position={[-5.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.001" }}
      />
      <mesh
        name="InteractiveTile002"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile002.geometry}
        material={materials["Material.007"]}
        position={[-4.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.002" }}
      />
      <mesh
        name="InteractiveTile003"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile003.geometry}
        material={materials["Material.007"]}
        position={[-3.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.003" }}
      />
      <mesh
        name="InteractiveTile004"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile004.geometry}
        material={materials["Material.004"]}
        position={[4.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.004" }}
      />
      <mesh
        name="InteractiveTile005"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile005.geometry}
        material={materials["Material.006"]}
        position={[-1.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.005" }}
      />
      <mesh
        name="InteractiveTile006"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile006.geometry}
        material={materials["Material.006"]}
        position={[5.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.006" }}
      />
      <mesh
        name="InteractiveTile007"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile007.geometry}
        material={materials["Material.007"]}
        position={[1.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.007" }}
      />
      <mesh
        name="InteractiveTile008"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile008.geometry}
        material={materials["Material.008"]}
        position={[4.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.008" }}
      />
      <mesh
        name="InteractiveTile009"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile009.geometry}
        material={materials["Material.007"]}
        position={[-2.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.009" }}
      />
      <mesh
        name="InteractiveTile010"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile010.geometry}
        material={materials["Material.005"]}
        position={[2.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.010" }}
      />
      <mesh
        name="InteractiveTile011"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile011.geometry}
        material={materials["Material.007"]}
        position={[-1.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.011" }}
      />
      <mesh
        name="InteractiveTile012"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile012.geometry}
        material={materials["Material.007"]}
        position={[-0.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.012" }}
      />
      <mesh
        name="InteractiveTile013"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile013.geometry}
        material={materials["Material.013"]}
        position={[-5.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.013" }}
      />
      <mesh
        name="InteractiveTile014"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile014.geometry}
        material={materials["Material.003"]}
        position={[0.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.014" }}
      />
      <mesh
        name="InteractiveTile015"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile015.geometry}
        material={materials["Material.001"]}
        position={[-5.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.015" }}
      />
      <mesh
        name="InteractiveTile016"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile016.geometry}
        material={materials["Material.005"]}
        position={[-5.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.016" }}
      />
      <mesh
        name="InteractiveTile017"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile017.geometry}
        material={materials["Material.006"]}
        position={[-5.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.017" }}
      />
      <mesh
        name="InteractiveTile018"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile018.geometry}
        material={materials["Material.007"]}
        position={[1.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.018" }}
      />
      <mesh
        name="InteractiveTile019"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile019.geometry}
        material={materials["Material.001"]}
        position={[-4.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.019" }}
      />
      <mesh
        name="InteractiveTile020"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile020.geometry}
        material={materials["Material.005"]}
        position={[-4.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.020" }}
      />
      <mesh
        name="InteractiveTile021"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile021.geometry}
        material={materials["Material.006"]}
        position={[-4.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.021" }}
      />
      <mesh
        name="InteractiveTile022"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile022.geometry}
        material={materials["Material.007"]}
        position={[-4.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.022" }}
      />
      <mesh
        name="InteractiveTile023"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile023.geometry}
        material={materials["Material.001"]}
        position={[-3.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.023" }}
      />
      <mesh
        name="InteractiveTile024"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile024.geometry}
        material={materials["Material.005"]}
        position={[-3.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.024" }}
      />
      <mesh
        name="InteractiveTile025"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile025.geometry}
        material={materials["Material.006"]}
        position={[-3.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.025" }}
      />
      <mesh
        name="InteractiveTile026"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile026.geometry}
        material={materials["Material.007"]}
        position={[-3.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.026" }}
      />
      <mesh
        name="InteractiveTile027"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile027.geometry}
        material={materials["Material.001"]}
        position={[-2.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.027" }}
      />
      <mesh
        name="InteractiveTile028"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile028.geometry}
        material={materials["Material.005"]}
        position={[-2.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.028" }}
      />
      <mesh
        name="InteractiveTile029"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile029.geometry}
        material={materials["Material.006"]}
        position={[-2.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.029" }}
      />
      <mesh
        name="InteractiveTile030"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile030.geometry}
        material={materials["Material.007"]}
        position={[-2.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.030" }}
      />
      <mesh
        name="InteractiveTile031"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile031.geometry}
        material={materials["Material.001"]}
        position={[-1.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.031" }}
      />
      <mesh
        name="InteractiveTile032"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile032.geometry}
        material={materials["Material.005"]}
        position={[-1.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.032" }}
      />
      <mesh
        name="InteractiveTile033"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile033.geometry}
        material={materials["Material.006"]}
        position={[-5.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.033" }}
      />
      <mesh
        name="InteractiveTile034"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile034.geometry}
        material={materials["Material.007"]}
        position={[-1.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.034" }}
      />
      <mesh
        name="InteractiveTile035"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile035.geometry}
        material={materials["Material.001"]}
        position={[1.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.035" }}
      />
      <mesh
        name="InteractiveTile036"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile036.geometry}
        material={materials["Material.005"]}
        position={[-0.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.036" }}
      />
      <mesh
        name="InteractiveTile037"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile037.geometry}
        material={materials["Material.006"]}
        position={[-4.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.037" }}
      />
      <mesh
        name="InteractiveTile038"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile038.geometry}
        material={materials["Material.007"]}
        position={[-0.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.038" }}
      />
      <mesh
        name="InteractiveTile039"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile039.geometry}
        material={materials["Material.001"]}
        position={[0.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.039" }}
      />
      <mesh
        name="InteractiveTile040"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile040.geometry}
        material={materials["Material.005"]}
        position={[0.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.040" }}
      />
      <mesh
        name="InteractiveTile041"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile041.geometry}
        material={materials["Material.006"]}
        position={[-3.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.041" }}
      />
      <mesh
        name="InteractiveTile042"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile042.geometry}
        material={materials["Material.007"]}
        position={[0.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.042" }}
      />
      <mesh
        name="InteractiveTile043"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile043.geometry}
        material={materials["Material.001"]}
        position={[-0.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.043" }}
      />
      <mesh
        name="InteractiveTile044"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile044.geometry}
        material={materials["Material.005"]}
        position={[1.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.044" }}
      />
      <mesh
        name="InteractiveTile045"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile045.geometry}
        material={materials["Material.006"]}
        position={[-2.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.045" }}
      />
      <mesh
        name="InteractiveTile046"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile046.geometry}
        material={materials["Material.007"]}
        position={[1.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.046" }}
      />
      <mesh
        name="InteractiveTile047"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile047.geometry}
        material={materials["Material.001"]}
        position={[2.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.047" }}
      />
      <mesh
        name="InteractiveTile048"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile048.geometry}
        material={materials["Material.005"]}
        position={[2.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.048" }}
      />
      <mesh
        name="InteractiveTile049"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile049.geometry}
        material={materials["Material.006"]}
        position={[2.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.049" }}
      />
      <mesh
        name="InteractiveTile050"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile050.geometry}
        material={materials["Material.007"]}
        position={[2.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.050" }}
      />
      <mesh
        name="InteractiveTile051"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile051.geometry}
        material={materials["Material.001"]}
        position={[3.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.051" }}
      />
      <mesh
        name="InteractiveTile052"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile052.geometry}
        material={materials["Material.005"]}
        position={[3.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.052" }}
      />
      <mesh
        name="InteractiveTile053"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile053.geometry}
        material={materials["Material.006"]}
        position={[3.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.053" }}
      />
      <mesh
        name="InteractiveTile054"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile054.geometry}
        material={materials["Material.007"]}
        position={[3.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.054" }}
      />
      <mesh
        name="InteractiveTile055"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile055.geometry}
        material={materials["Material.001"]}
        position={[4.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.055" }}
      />
      <mesh
        name="InteractiveTile056"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile056.geometry}
        material={materials["Material.005"]}
        position={[-1.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.056" }}
      />
      <mesh
        name="InteractiveTile057"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile057.geometry}
        material={materials["Material.015"]}
        position={[4.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.057" }}
      />
      <mesh
        name="InteractiveTile058"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile058.geometry}
        material={materials["Material.007"]}
        position={[4.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.058" }}
      />
      <mesh
        name="InteractiveTile059"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile059.geometry}
        material={materials["Material.001"]}
        position={[5.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.059" }}
      />
      <mesh
        name="InteractiveTile060"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile060.geometry}
        material={materials["Material.005"]}
        position={[0.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.060" }}
      />
      <mesh
        name="InteractiveTile061"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile061.geometry}
        material={materials["Material.006"]}
        position={[5.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.061" }}
      />
      <mesh
        name="InteractiveTile062"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile062.geometry}
        material={materials["Material.007"]}
        position={[5.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.062" }}
      />
      <mesh
        name="InteractiveTile063"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile063.geometry}
        material={materials["Material.005"]}
        position={[3.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.063" }}
      />
      <mesh
        name="InteractiveTile064"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile064.geometry}
        material={materials["Material.005"]}
        position={[-0.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.064" }}
      />
      <mesh
        name="InteractiveTile065"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile065.geometry}
        material={materials["Material.005"]}
        position={[-0.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.065" }}
      />
      <mesh
        name="InteractiveTile066"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile066.geometry}
        material={materials["Material.007"]}
        position={[0.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.066" }}
      />
      <mesh
        name="InteractiveTile067"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile067.geometry}
        material={materials["Material.007"]}
        position={[1.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.067" }}
      />
      <mesh
        name="InteractiveTile068"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile068.geometry}
        material={materials["Material.007"]}
        position={[2.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.068" }}
      />
      <mesh
        name="InteractiveTile069"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile069.geometry}
        material={materials["Material.007"]}
        position={[3.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.069" }}
      />
      <mesh
        name="InteractiveTile070"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile070.geometry}
        material={materials["Material.007"]}
        position={[4.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.070" }}
      />
      <mesh
        name="InteractiveTile071"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile071.geometry}
        material={materials["Material.007"]}
        position={[5.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.071" }}
      />
      <mesh
        name="InteractiveTile072"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile072.geometry}
        material={materials["Material.013"]}
        position={[-5.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.072" }}
      />
      <mesh
        name="InteractiveTile073"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile073.geometry}
        material={materials["Material.007"]}
        position={[-4.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.073" }}
      />
      <mesh
        name="InteractiveTile074"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile074.geometry}
        material={materials["Material.007"]}
        position={[-3.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.074" }}
      />
      <mesh
        name="InteractiveTile075"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile075.geometry}
        material={materials["Material.007"]}
        position={[-2.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.075" }}
      />
      <mesh
        name="InteractiveTile076"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile076.geometry}
        material={materials["Material.007"]}
        position={[-1.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.076" }}
      />
      <mesh
        name="InteractiveTile077"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile077.geometry}
        material={materials["Material.007"]}
        position={[-0.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.077" }}
      />
      <mesh
        name="InteractiveTile078"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile078.geometry}
        material={materials["Material.007"]}
        position={[0.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.078" }}
      />
      <mesh
        name="InteractiveTile079"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile079.geometry}
        material={materials["Material.007"]}
        position={[1.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.079" }}
      />
      <mesh
        name="InteractiveTile080"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile080.geometry}
        material={materials["Material.007"]}
        position={[2.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.080" }}
      />
      <mesh
        name="InteractiveTile081"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile081.geometry}
        material={materials["Material.007"]}
        position={[3.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.081" }}
      />
      <mesh
        name="InteractiveTile082"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile082.geometry}
        material={materials["Material.007"]}
        position={[4.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.082" }}
      />
      <mesh
        name="InteractiveTile083"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile083.geometry}
        material={materials["Material.007"]}
        position={[5.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.083" }}
      />
      <mesh
        name="InteractiveTile084"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile084.geometry}
        material={materials["Material.013"]}
        position={[-5.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.084" }}
      />
      <mesh
        name="InteractiveTile085"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile085.geometry}
        material={materials["Material.007"]}
        position={[-4.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.085" }}
      />
      <mesh
        name="InteractiveTile086"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile086.geometry}
        material={materials["Material.007"]}
        position={[-3.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.086" }}
      />
      <mesh
        name="InteractiveTile087"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile087.geometry}
        material={materials["Material.007"]}
        position={[-2.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.087" }}
      />
      <mesh
        name="InteractiveTile088"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile088.geometry}
        material={materials["Material.007"]}
        position={[-1.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.088" }}
      />
      <mesh
        name="InteractiveTile089"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile089.geometry}
        material={materials["Material.007"]}
        position={[-0.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.089" }}
      />
      <mesh
        name="InteractiveTile090"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile090.geometry}
        material={materials["Material.007"]}
        position={[0.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.090" }}
      />
      <mesh
        name="InteractiveTile091"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile091.geometry}
        material={materials["Material.007"]}
        position={[1.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.091" }}
      />
      <mesh
        name="InteractiveTile092"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile092.geometry}
        material={materials["Material.007"]}
        position={[2.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.092" }}
      />
      <mesh
        name="InteractiveTile093"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile093.geometry}
        material={materials["Material.007"]}
        position={[3.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.093" }}
      />
      <mesh
        name="InteractiveTile094"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile094.geometry}
        material={materials["Material.007"]}
        position={[4.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.094" }}
      />
      <mesh
        name="InteractiveTile095"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile095.geometry}
        material={materials["Material.007"]}
        position={[5.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.095" }}
      />
      <mesh
        name="InteractiveTile096"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile096.geometry}
        material={materials["Material.001"]}
        position={[5.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.096" }}
      />
      <mesh
        name="InteractiveTile097"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile097.geometry}
        material={materials["Material.004"]}
        position={[4.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.097" }}
      />
      <mesh
        name="InteractiveTile098"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile098.geometry}
        material={materials["Material.006"]}
        position={[5.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.098" }}
      />
      <mesh
        name="InteractiveTile099"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile099.geometry}
        material={materials["Material.008"]}
        position={[4.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.099" }}
      />
      <mesh
        name="InteractiveTile100"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile100.geometry}
        material={materials["Material.005"]}
        position={[-5.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.100" }}
      />
      <mesh
        name="InteractiveTile101"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile101.geometry}
        material={materials["Material.005"]}
        position={[-4.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.101" }}
      />
      <mesh
        name="InteractiveTile102"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile102.geometry}
        material={materials["Material.005"]}
        position={[-3.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.102" }}
      />
      <mesh
        name="InteractiveTile103"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile103.geometry}
        material={materials["Material.005"]}
        position={[-2.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.103" }}
      />
      <mesh
        name="InteractiveTile104"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile104.geometry}
        material={materials["Material.005"]}
        position={[-1.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.104" }}
      />
      <mesh
        name="InteractiveTile105"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile105.geometry}
        material={materials["Material.006"]}
        position={[-5.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.105" }}
      />
      <mesh
        name="InteractiveTile106"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile106.geometry}
        material={materials["Material.001"]}
        position={[1.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.106" }}
      />
      <mesh
        name="InteractiveTile107"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile107.geometry}
        material={materials["Material.005"]}
        position={[-0.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.107" }}
      />
      <mesh
        name="InteractiveTile108"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile108.geometry}
        material={materials["Material.006"]}
        position={[-4.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.108" }}
      />
      <mesh
        name="InteractiveTile109"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile109.geometry}
        material={materials["Material.001"]}
        position={[0.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.109" }}
      />
      <mesh
        name="InteractiveTile110"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile110.geometry}
        material={materials["Material.005"]}
        position={[0.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.110" }}
      />
      <mesh
        name="InteractiveTile111"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile111.geometry}
        material={materials["Material.006"]}
        position={[-3.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.111" }}
      />
      <mesh
        name="InteractiveTile112"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile112.geometry}
        material={materials["Material.001"]}
        position={[-0.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.112" }}
      />
      <mesh
        name="InteractiveTile113"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile113.geometry}
        material={materials["Material.005"]}
        position={[1.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.113" }}
      />
      <mesh
        name="InteractiveTile114"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile114.geometry}
        material={materials["Material.006"]}
        position={[-2.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.114" }}
      />
      <mesh
        name="InteractiveTile115"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile115.geometry}
        material={materials["Material.005"]}
        position={[2.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.115" }}
      />
      <mesh
        name="InteractiveTile116"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile116.geometry}
        material={materials["Material.005"]}
        position={[3.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.116" }}
      />
      <mesh
        name="InteractiveTile117"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile117.geometry}
        material={materials["Material.006"]}
        position={[-1.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.117" }}
      />
      <mesh
        name="InteractiveTile118"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile118.geometry}
        material={materials["Material.005"]}
        position={[2.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.118" }}
      />
      <mesh
        name="InteractiveTile119"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile119.geometry}
        material={materials["Material.005"]}
        position={[3.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.119" }}
      />
      <mesh
        name="InteractiveTile120"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile120.geometry}
        material={materials["Material.013"]}
        position={[-7.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.120" }}
      />
      <mesh
        name="InteractiveTile121"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile121.geometry}
        material={materials["Material.001"]}
        position={[-7.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.121" }}
      />
      <mesh
        name="InteractiveTile122"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile122.geometry}
        material={materials["Material.005"]}
        position={[-7.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.122" }}
      />
      <mesh
        name="InteractiveTile123"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile123.geometry}
        material={materials["Material.006"]}
        position={[-7.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.123" }}
      />
      <mesh
        name="InteractiveTile124"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile124.geometry}
        material={materials["Material.001"]}
        position={[-6.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.124" }}
      />
      <mesh
        name="InteractiveTile125"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile125.geometry}
        material={materials["Material.005"]}
        position={[-6.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.125" }}
      />
      <mesh
        name="InteractiveTile126"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile126.geometry}
        material={materials["Material.006"]}
        position={[-6.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.126" }}
      />
      <mesh
        name="InteractiveTile127"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile127.geometry}
        material={materials["Material.007"]}
        position={[-6.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.127" }}
      />
      <mesh
        name="InteractiveTile128"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile128.geometry}
        material={materials["Material.006"]}
        position={[-7.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.128" }}
      />
      <mesh
        name="InteractiveTile129"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile129.geometry}
        material={materials["Material.006"]}
        position={[-6.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.129" }}
      />
      <mesh
        name="InteractiveTile130"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile130.geometry}
        material={materials["Material.013"]}
        position={[-7.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.130" }}
      />
      <mesh
        name="InteractiveTile131"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile131.geometry}
        material={materials["Material.007"]}
        position={[-6.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.131" }}
      />
      <mesh
        name="InteractiveTile132"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile132.geometry}
        material={materials["Material.013"]}
        position={[-7.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.132" }}
      />
      <mesh
        name="InteractiveTile133"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile133.geometry}
        material={materials["Material.007"]}
        position={[-6.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.133" }}
      />
      <mesh
        name="InteractiveTile134"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile134.geometry}
        material={materials["Material.013"]}
        position={[-7.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.134" }}
      />
      <mesh
        name="InteractiveTile135"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile135.geometry}
        material={materials["Material.007"]}
        position={[-6.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.135" }}
      />
      <mesh
        name="InteractiveTile136"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile136.geometry}
        material={materials["Material.005"]}
        position={[-7.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.136" }}
      />
      <mesh
        name="InteractiveTile137"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile137.geometry}
        material={materials["Material.005"]}
        position={[-6.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.137" }}
      />
      <mesh
        name="InteractiveTile138"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile138.geometry}
        material={materials["Material.006"]}
        position={[-7.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.138" }}
      />
      <mesh
        name="InteractiveTile139"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile139.geometry}
        material={materials["Material.006"]}
        position={[-6.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.139" }}
      />
      <mesh
        name="InteractiveTile140"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile140.geometry}
        material={materials["Material.001"]}
        position={[7.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.140" }}
      />
      <mesh
        name="InteractiveTile141"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile141.geometry}
        material={materials["Material.004"]}
        position={[6.5, 0, 2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.141" }}
      />
      <mesh
        name="InteractiveTile142"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile142.geometry}
        material={materials["Material.006"]}
        position={[7.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.142" }}
      />
      <mesh
        name="InteractiveTile143"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile143.geometry}
        material={materials["Material.008"]}
        position={[6.5, 0, 1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.143" }}
      />
      <mesh
        name="InteractiveTile144"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile144.geometry}
        material={materials["Material.001"]}
        position={[6.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.144" }}
      />
      <mesh
        name="InteractiveTile145"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile145.geometry}
        material={materials["Material.015"]}
        position={[6.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.145" }}
      />
      <mesh
        name="InteractiveTile146"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile146.geometry}
        material={materials["Material.007"]}
        position={[6.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.146" }}
      />
      <mesh
        name="InteractiveTile147"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile147.geometry}
        material={materials["Material.001"]}
        position={[7.5, 0, 0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.147" }}
      />
      <mesh
        name="InteractiveTile148"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile148.geometry}
        material={materials["Material.006"]}
        position={[7.5, 0, -0.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.148" }}
      />
      <mesh
        name="InteractiveTile149"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile149.geometry}
        material={materials["Material.007"]}
        position={[7.5, 0, -1.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.149" }}
      />
      <mesh
        name="InteractiveTile150"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile150.geometry}
        material={materials["Material.007"]}
        position={[6.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.150" }}
      />
      <mesh
        name="InteractiveTile151"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile151.geometry}
        material={materials["Material.007"]}
        position={[7.5, 0, -2.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.151" }}
      />
      <mesh
        name="InteractiveTile152"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile152.geometry}
        material={materials["Material.007"]}
        position={[6.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.152" }}
      />
      <mesh
        name="InteractiveTile153"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile153.geometry}
        material={materials["Material.007"]}
        position={[7.5, 0, -3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.153" }}
      />
      <mesh
        name="InteractiveTile154"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile154.geometry}
        material={materials["Material.007"]}
        position={[6.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.154" }}
      />
      <mesh
        name="InteractiveTile155"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile155.geometry}
        material={materials["Material.007"]}
        position={[7.5, 0, -4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.155" }}
      />
      <mesh
        name="InteractiveTile156"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile156.geometry}
        material={materials["Material.001"]}
        position={[7.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.156" }}
      />
      <mesh
        name="InteractiveTile157"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile157.geometry}
        material={materials["Material.004"]}
        position={[6.5, 0, 4.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.157" }}
      />
      <mesh
        name="InteractiveTile158"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile158.geometry}
        material={materials["Material.006"]}
        position={[7.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.158" }}
      />
      <mesh
        name="InteractiveTile159"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile159.geometry}
        material={materials["Material.008"]}
        position={[6.5, 0, 3.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.159" }}
      />
      <mesh
        name="InteractiveTile160"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile160.geometry}
        material={materials["Material.013"]}
        position={[-5.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.160" }}
      />
      <mesh
        name="InteractiveTile161"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile161.geometry}
        material={materials["Material.007"]}
        position={[-4.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.161" }}
      />
      <mesh
        name="InteractiveTile162"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile162.geometry}
        material={materials["Material.007"]}
        position={[-3.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.162" }}
      />
      <mesh
        name="InteractiveTile163"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile163.geometry}
        material={materials["Material.007"]}
        position={[-2.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.163" }}
      />
      <mesh
        name="InteractiveTile164"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile164.geometry}
        material={materials["Material.007"]}
        position={[-1.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.164" }}
      />
      <mesh
        name="InteractiveTile165"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile165.geometry}
        material={materials["Material.007"]}
        position={[-0.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.165" }}
      />
      <mesh
        name="InteractiveTile166"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile166.geometry}
        material={materials["Material.007"]}
        position={[0.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.166" }}
      />
      <mesh
        name="InteractiveTile167"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile167.geometry}
        material={materials["Material.007"]}
        position={[1.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.167" }}
      />
      <mesh
        name="InteractiveTile168"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile168.geometry}
        material={materials["Material.007"]}
        position={[2.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.168" }}
      />
      <mesh
        name="InteractiveTile169"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile169.geometry}
        material={materials["Material.007"]}
        position={[3.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.169" }}
      />
      <mesh
        name="InteractiveTile170"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile170.geometry}
        material={materials["Material.007"]}
        position={[4.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.170" }}
      />
      <mesh
        name="InteractiveTile171"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile171.geometry}
        material={materials["Material.007"]}
        position={[5.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.171" }}
      />
      <mesh
        name="InteractiveTile172"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile172.geometry}
        material={materials["Material.013"]}
        position={[-7.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.172" }}
      />
      <mesh
        name="InteractiveTile173"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile173.geometry}
        material={materials["Material.007"]}
        position={[-6.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.173" }}
      />
      <mesh
        name="InteractiveTile174"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile174.geometry}
        material={materials["Material.007"]}
        position={[6.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.174" }}
      />
      <mesh
        name="InteractiveTile175"
        castShadow
        receiveShadow
        geometry={nodes.InteractiveTile175.geometry}
        material={materials["Material.007"]}
        position={[7.5, 0, -5.5]}
        scale={[0.5, 0.1, 0.5]}
        userData={{ name: "InteractiveTile.175" }}
      />
      <group
        name="tileLow_graveyard005"
        position={[0.02, -1, -0.57]}
        scale={[7.9, 1, 5.51]}
        userData={{ name: "tileLow_graveyard.005" }}
      >
        <mesh
          name="Cube216"
          castShadow
          receiveShadow
          geometry={nodes.Cube216.geometry}
          material={materials["Mud.015"]}
        />
        <mesh
          name="Cube216_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube216_1.geometry}
          material={materials["DarkWood.028"]}
        />
      </group>
      <mesh
        name="pathDirt005"
        castShadow
        receiveShadow
        geometry={nodes.pathDirt005.geometry}
        material={materials["DarkWood.033"]}
        position={[1.66, 0, -4.96]}
        userData={{ name: "pathDirt.005" }}
      />
      <mesh
        name="pathDirt006"
        castShadow
        receiveShadow
        geometry={nodes.pathDirt006.geometry}
        material={materials["DarkWood.033"]}
        position={[-1.48, 0, 3.71]}
        userData={{ name: "pathDirt.006" }}
      />
      <mesh
        name="pathCobbled009"
        castShadow
        receiveShadow
        geometry={nodes.pathCobbled009.geometry}
        material={materials["Stone.044"]}
        position={[-6.58, 0, -4.65]}
        userData={{ name: "pathCobbled.009" }}
      />
      <mesh
        name="pathCobbled010"
        castShadow
        receiveShadow
        geometry={nodes.pathCobbled010.geometry}
        material={materials["Stone.044"]}
        position={[6.42, 0, 3.57]}
        userData={{ name: "pathCobbled.010" }}
      />
      <mesh
        name="detail_graveyard005"
        castShadow
        receiveShadow
        geometry={nodes.detail_graveyard005.geometry}
        material={materials["DarkWood.034"]}
        position={[5.51, 0, -1.11]}
        userData={{ name: "detail_graveyard.005" }}
      />
      <mesh
        name="detail_graveyard006"
        castShadow
        receiveShadow
        geometry={nodes.detail_graveyard006.geometry}
        material={materials["DarkWood.034"]}
        position={[-5.8, 0, -0.27]}
        userData={{ name: "detail_graveyard.006" }}
      />
      <mesh
        name="pathCobbled024"
        castShadow
        receiveShadow
        geometry={nodes.pathCobbled024.geometry}
        material={materials["Stone.056"]}
        position={[-6.58, 0, -2.65]}
        userData={{ name: "pathCobbled.024" }}
      />
      <mesh
        name="pathCobbled025"
        castShadow
        receiveShadow
        geometry={nodes.pathCobbled025.geometry}
        material={materials["Stone.057"]}
        position={[6.42, 0, 1.57]}
        userData={{ name: "pathCobbled.025" }}
      />
      <mesh
        name="pathCobbled026"
        castShadow
        receiveShadow
        geometry={nodes.pathCobbled026.geometry}
        material={materials["Stone.058"]}
        position={[-2.02, 0, -0.46]}
        userData={{ name: "pathCobbled.026" }}
      />
      <mesh
        name="pathCobbled027"
        castShadow
        receiveShadow
        geometry={nodes.pathCobbled027.geometry}
        material={materials["Stone.059"]}
        position={[1.98, 0, -0.46]}
        userData={{ name: "pathCobbled.027" }}
      />
      <mesh
        name="pathCobbled028"
        castShadow
        receiveShadow
        geometry={nodes.pathCobbled028.geometry}
        material={materials["Stone.060"]}
        position={[1.5, 0, 1.54]}
        userData={{ name: "pathCobbled.028" }}
      />
      <mesh
        name="pathCobbled029"
        castShadow
        receiveShadow
        geometry={nodes.pathCobbled029.geometry}
        material={materials["Stone.061"]}
        position={[-0.93, 0, -2.46]}
        userData={{ name: "pathCobbled.029" }}
      />
      <mesh
        name="pathCobbled030"
        castShadow
        receiveShadow
        geometry={nodes.pathCobbled030.geometry}
        material={materials["Stone.062"]}
        position={[-0.02, 0, -0.46]}
        userData={{ name: "pathCobbled.030" }}
      />
      <group
        name="fenceSingle021"
        position={[-0.47, 0, 3.42]}
        rotation={[0, -1.57, 0]}
        userData={{ name: "fenceSingle.021" }}
      >
        <mesh
          name="Cylinder081"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder081.geometry}
          material={materials["Black.057"]}
        />
        <mesh
          name="Cylinder081_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder081_1.geometry}
          material={materials["Stone.075"]}
        />
      </group>
      <group
        name="fenceSingle022"
        position={[-3.55, 0, 2.4]}
        rotation={[0, -1.57, 0]}
        userData={{ name: "fenceSingle.022" }}
      >
        <mesh
          name="Cylinder082"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder082.geometry}
          material={materials["Black.058"]}
        />
        <mesh
          name="Cylinder082_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder082_1.geometry}
          material={materials["Stone.076"]}
        />
      </group>
      <group
        name="fenceSingle023"
        position={[3.46, 0, -3.48]}
        rotation={[0, -1.57, 0]}
        userData={{ name: "fenceSingle.023" }}
      >
        <mesh
          name="Cylinder083"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder083.geometry}
          material={materials["Black.059"]}
        />
        <mesh
          name="Cylinder083_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder083_1.geometry}
          material={materials["Stone.077"]}
        />
      </group>
      <group
        name="fenceSingle024"
        position={[0.46, 0, -4.42]}
        rotation={[0, -1.57, 0]}
        userData={{ name: "fenceSingle.024" }}
      >
        <mesh
          name="Cylinder084"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder084.geometry}
          material={materials["Black.060"]}
        />
        <mesh
          name="Cylinder084_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder084_1.geometry}
          material={materials["Stone.078"]}
        />
      </group>
      <group
        name="fenceSingle025"
        position={[-3.55, 0, -3.51]}
        rotation={[0, -1.57, 0]}
        userData={{ name: "fenceSingle.025" }}
      >
        <mesh
          name="Cylinder085"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder085.geometry}
          material={materials["Black.061"]}
        />
        <mesh
          name="Cylinder085_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder085_1.geometry}
          material={materials["Stone.079"]}
        />
      </group>
      <group
        name="fenceSingle026"
        position={[3.46, 0, 2.51]}
        rotation={[0, -1.57, 0]}
        userData={{ name: "fenceSingle.026" }}
      >
        <mesh
          name="Cylinder103"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder103.geometry}
          material={materials["Black.062"]}
        />
        <mesh
          name="Cylinder103_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder103_1.geometry}
          material={materials["Stone.080"]}
        />
      </group>
      <group
        name="pumpkinSmall007"
        position={[3.32, 0.2, 2.02]}
        userData={{ name: "pumpkinSmall.007" }}
      >
        <mesh
          name="Sphere014"
          castShadow
          receiveShadow
          geometry={nodes.Sphere014.geometry}
          material={materials["Orange.024"]}
        />
        <mesh
          name="Sphere014_1"
          castShadow
          receiveShadow
          geometry={nodes.Sphere014_1.geometry}
          material={materials["GreenDark.012"]}
        />
      </group>
      <group
        name="tileSmall_graveyard009"
        position={[-7.53, -0.94, 4.5]}
        userData={{ name: "tileSmall_graveyard.009" }}
      >
        <mesh
          name="Cube309"
          castShadow
          receiveShadow
          geometry={nodes.Cube309.geometry}
          material={materials["Mud.062"]}
        />
        <mesh
          name="Cube309_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube309_1.geometry}
          material={materials["DarkWood.099"]}
        />
      </group>
      <group
        name="tileSmall_graveyard010"
        position={[-7.53, -0.94, 3.5]}
        userData={{ name: "tileSmall_graveyard.010" }}
      >
        <mesh
          name="Cube310"
          castShadow
          receiveShadow
          geometry={nodes.Cube310.geometry}
          material={materials["Mud.062"]}
        />
        <mesh
          name="Cube310_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube310_1.geometry}
          material={materials["DarkWood.099"]}
        />
      </group>
      <group
        name="tileSmall_graveyard011"
        position={[-7.53, -0.94, 2.5]}
        userData={{ name: "tileSmall_graveyard.011" }}
      >
        <mesh
          name="Cube311"
          castShadow
          receiveShadow
          geometry={nodes.Cube311.geometry}
          material={materials["Mud.062"]}
        />
        <mesh
          name="Cube311_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube311_1.geometry}
          material={materials["DarkWood.099"]}
        />
      </group>
      <group
        name="tileSmall_graveyard012"
        position={[-7.53, -0.94, 1.5]}
        userData={{ name: "tileSmall_graveyard.012" }}
      >
        <mesh
          name="Cube312"
          castShadow
          receiveShadow
          geometry={nodes.Cube312.geometry}
          material={materials["Mud.062"]}
        />
        <mesh
          name="Cube312_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube312_1.geometry}
          material={materials["DarkWood.099"]}
        />
      </group>
      <group
        name="tileSmall_graveyard013"
        position={[7.47, -0.94, -2.5]}
        userData={{ name: "tileSmall_graveyard.013" }}
      >
        <mesh
          name="Cube313"
          castShadow
          receiveShadow
          geometry={nodes.Cube313.geometry}
          material={materials["Mud.062"]}
        />
        <mesh
          name="Cube313_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube313_1.geometry}
          material={materials["DarkWood.099"]}
        />
      </group>
      <group
        name="tileSmall_graveyard014"
        position={[7.47, -0.94, -3.5]}
        userData={{ name: "tileSmall_graveyard.014" }}
      >
        <mesh
          name="Cube314"
          castShadow
          receiveShadow
          geometry={nodes.Cube314.geometry}
          material={materials["Mud.062"]}
        />
        <mesh
          name="Cube314_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube314_1.geometry}
          material={materials["DarkWood.099"]}
        />
      </group>
      <group
        name="tileSmall_graveyard015"
        position={[7.47, -0.94, -4.5]}
        userData={{ name: "tileSmall_graveyard.015" }}
      >
        <mesh
          name="Cube315"
          castShadow
          receiveShadow
          geometry={nodes.Cube315.geometry}
          material={materials["Mud.062"]}
        />
        <mesh
          name="Cube315_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube315_1.geometry}
          material={materials["DarkWood.099"]}
        />
      </group>
      <group
        name="tileSmall_graveyard016"
        position={[7.47, -0.94, -5.5]}
        userData={{ name: "tileSmall_graveyard.016" }}
      >
        <mesh
          name="Cube316"
          castShadow
          receiveShadow
          geometry={nodes.Cube316.geometry}
          material={materials["Mud.062"]}
        />
        <mesh
          name="Cube316_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube316_1.geometry}
          material={materials["DarkWood.099"]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(URL);
